import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '~/store';

export const financePageSelector = (state: RootState) => state.finance.page;

export const isConnectedPayoutMethodSelector = createSelector(
  financePageSelector,
  ({ info }) => !!info?.attached?.uuid && info.attached?.uuid !== '',
);
